export default __webpack_public_path__ + "static/media/BlissPro-Regular.fdc20d6f.ttf";